import marked from 'marked'
import copy from 'copy-to-clipboard'

export function generate (markdown) {
  const withMarker = `${markdown}\n\n<!-- generated by vue-issues. DO NOT REMOVE -->`

  copy(withMarker)

  return {
    markdown: withMarker,
    html: marked(markdown, {
      gfm: true,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: true,
      smartLists: true,
      smartypants: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/generate.js